module.exports = __webpack_public_path__ + "img/Realisme_Tida_og_samfunnsforholdene1.80d8119c.jpg";